import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { logger } from '../utils/logger';
import { classifyAuthError } from '../utils/authDiagnostics';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        try {
          const user = await processGoogleSession(sessionId);
          // Navigate to dashboard with user data to skip auth check
          navigate('/dashboard', { state: { user }, replace: true });
        } catch (err) {
          logger.error('Google session processing failed:', err?.response?.data || err.message);
          const reason = classifyAuthError(err) || 'auth_failed';
          navigate(`/login?error=auth_failed&reason=${reason}`, { replace: true });
        }
      } else {
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [location.hash, navigate, processGoogleSession]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 size={48} className="animate-spin text-[#002fa7] mx-auto mb-4" />
        <p className="text-[#4b5563]">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
